import type { FormOptions } from '@customTypes/types';

export const helpWithOptions: FormOptions = {
  accessAndPermissions: 'HPE GreenLake Marketplace Access & Permissions',
  portalExperience: 'HPE GreenLake Marketplace Portal Experience',
  downloadingAndDeployingOfSoftware: 'Downloading and Deploying Software from HPE GreenLake Marketplace',
  configurationOfSoftware: 'Configuration of Software',
  softwareRuntimeError: 'Software Runtime Error',
  other: 'Other',
};
